import React, { useState } from "react";
import './ErrorPage.css'
function ErrorPage({ props, message, action }) {

    if (message === 'Token Expired') {
        // setShowLoginButton(true)
    }
    console.log("Error message: ", message);
    return (<div>
        <section className="items-center error-style"

            style={{
                backgroundImage: ' url(background.png)',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                // height: '100vh',
                minHeight: '100vh'
            }}>

            <div className="error-container text-white bold font-roboto pt-40">
                <div className="error-subcontainer">
                    <div className="image-container">
                        {/* <img src="smiley.png" className="flex justify-center items-center w-24 h-24 ml-52 mb-6 invert" alt="logo"></img> */}
                        <div><img src="smiley.png" className="w-24 h-24  mb-8 invert" alt="logo"></img></div>
                    </div>
                    <div className="text-center font-roboto text-6xl pb-3 mb-5">OopS!</div>
                    <div className="font-sans-serif text-xl" >{message}</div>

                    {message === 'Token Expired' && <div><button type="button" onClick={() => { window.location.href = '/'; }} className="text-white bg-gradient-to-br from-purple-600 to-blue-500 hover:bg-gradient-to-bl focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-10 py-3 text-center mr-2 mb-2">Login Again</button></div>}
                </div>
            </div>

        </section>
    </div>)

}
export default ErrorPage;